import { useAtomValue } from 'jotai'
import React from 'react'
import { match } from 'ts-pattern'

import { dialogInfoAtom } from '../atoms'

import { AddCoreMemberDialog } from './AddCoreMemberDialog'
import { DeleteCoreMemberDialog } from './DeleteCoreMemberDialog'

export const Dialogs = () => {
  const dialogInfo = useAtomValue(dialogInfoAtom)

  return match(dialogInfo?.dialogType)
    .with(undefined, () => null)
    .with('add', () => <AddCoreMemberDialog />)
    .with('delete', () => <DeleteCoreMemberDialog />)
    .exhaustive()
}
